import '../styles/_app.scss';
import React from 'react';
import { Provider } from 'react-redux';
import { Router } from 'react-router-dom';
import EgretTheme from './EgretLayout/EgretTheme/EgretTheme';
import AppContext from './appContext';
import routes from './RootRoutes';
import { Store } from './redux/Store';
import Auth from './auth/Auth';
import EgretLayout from './EgretLayout/EgretLayout';
import AuthGuard from './auth/AuthGuard';
import 'devextreme/dist/css/dx.common.css';
import 'devextreme/dist/css/dx.light.css';
import { useVisitorData } from '@fingerprintjs/fingerprintjs-pro-react';
import history from 'history.js';

const App = () => {
  // const { isLoading, error, data, getData } = useVisitorData({ extendedResult: true }, { immediate: true });
  useVisitorData({ extendedResult: true }, { immediate: true });

  return (
    <AppContext.Provider value={{ routes }}>
      <Provider store={Store}>
        <EgretTheme>
          <Auth>
            <Router history={history}>
              <AuthGuard>
                <EgretLayout />
              </AuthGuard>
            </Router>
          </Auth>
        </EgretTheme>
      </Provider>
    </AppContext.Provider>
  );
};

export default App;
